import React from 'react';
import { motion } from 'framer-motion';
import { AMBASSADOR_AVATAR } from '../constants/media';
import { useLanguage } from '../contexts/LanguageContext';
import { LINKS } from '../data/translations';
export function CtaSection() {
  const {
    t
  } = useLanguage();
  return <section id="get-started" className="w-full bg-blue-600" data-id="element-44" data-mp="m1i6o05olnse">
      <div className="mx-auto w-full max-w-[1000px] px-5 py-24 text-center sm:px-8 lg:py-32" data-id="element-45" data-mp="m3301mg9f0oo">
        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-80px'
      }} transition={{
        duration: 0.5,
        ease: 'easeOut'
      }} className="text-[clamp(2.25rem,5.5vw,4rem)] font-extrabold leading-[1.05] tracking-[-0.035em] text-white" data-id="element-46" data-mp="r038u54huhjh">
          {t.cta.title}
        </motion.h2>

        <div className="mx-auto mt-12 max-w-[720px] rounded-3xl bg-white/10 p-7 text-left ring-1 ring-white/15" data-id="element-47" data-mp="19sdukm70nyud">
          <div className="flex flex-col items-center gap-6 sm:flex-row sm:items-start" data-id="element-48" data-mp="1eqp2grdr3z9y">
            <img src={AMBASSADOR_AVATAR} alt="Joko Prabuwesi, TokoTeta ambassador robot" className="h-[110px] w-[110px] shrink-0 rounded-full object-cover" data-id="element-49" data-mp="3nakqfr7l9ybn" />
            <div data-id="element-50" data-mp="3dc3usgxpgvj9">
              <p className="flex items-center gap-2 text-[13px] font-bold uppercase tracking-wide text-blue-100" data-id="element-51" data-mp="3ddojhpxc9k97">
                <span className="h-2 w-2 rounded-full bg-white" aria-hidden="true" data-id="element-52" data-mp="9uvgu863mftt" />
                {t.cta.quoteLabel}
              </p>
              <p className="mt-3 text-[22px] italic leading-snug text-white" data-id="element-53" data-mp="4y4skxk54dxb">
                {t.cta.quote}
              </p>
            </div>
          </div>
        </div>

        <a href={LINKS.register} target="_blank" rel="noreferrer" className="mt-14 inline-flex items-center justify-center rounded-full bg-white px-12 py-5 text-[19px] font-bold text-blue-600 shadow-xl transition-transform hover:scale-[1.02]" data-id="element-54" data-mp="3s8csvf5v12u3">
          {t.cta.button}
        </a>
        <p className="mt-6 text-[15px] text-blue-100/90" data-id="element-55" data-mp="2i4upl9d16g8r">{t.cta.note}</p>
      </div>
    </section>;
}